import {
  AuthApi,
  Profile,
  AuthV1UserPartialUpdateRequest,
  User,
  AuthV1ProfilePartialUpdateRequest,
  AuthV1UserAttachmentsListRequest,
  InlineResponse200,
  AuthV1ProfilePassportUpdateRequest,
  AuthV1ProfileRegisterRequest,
} from '@/requests/mainApi';
import { IResponse, requestMachine } from '@/requests/requestMachine';
import { PassportData } from '../mainApi/models/PassportData';

export default {
  updateUserData(variables: AuthV1UserPartialUpdateRequest): Promise<IResponse<User>> {
    return requestMachine<User, AuthV1UserPartialUpdateRequest>(AuthApi, 'authV1UserPartialUpdate', true, variables);
  },
  getProfileData(): Promise<IResponse<Profile>> {
    return requestMachine<Profile>(AuthApi, 'authV1ProfileRead', true);
  },
  updateProfileData(variables: AuthV1ProfilePartialUpdateRequest): Promise<IResponse<Profile>> {
    return requestMachine<Profile, AuthV1ProfilePartialUpdateRequest>(
      AuthApi,
      'authV1ProfilePartialUpdate',
      true,
      variables
    );
  },

  registerProfileData(variables: AuthV1ProfileRegisterRequest): Promise<IResponse<Profile>> {
    return requestMachine<Profile, AuthV1ProfileRegisterRequest>(AuthApi, 'authV1ProfileRegister', true, variables);
  },
  updatePassportData(variables: AuthV1ProfilePassportUpdateRequest): Promise<IResponse<PassportData>> {
    return requestMachine<PassportData, AuthV1ProfilePassportUpdateRequest>(
      AuthApi,
      'authV1ProfilePassportUpdate',
      true,
      variables
    );
  },
  getUserDocuments(variables: AuthV1UserAttachmentsListRequest): Promise<IResponse<InlineResponse200>> {
    return requestMachine<InlineResponse200, AuthV1UserAttachmentsListRequest>(
      AuthApi,
      'authV1UserAttachmentsList',
      true,
      variables
    );
  },
};
